import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M8.956 2C5.7 2 3 4.997 3 7.956c0 1.053.006 2.4.449 3.728a1 1 0 0 1-1.898.632C1 10.662 1 9.027 1 7.991v-.035C1 3.96 4.529 0 8.956 0a7.949 7.949 0 0 1 6.578 3.478h.379c1.665 0 3.28.581 4.493 1.539C21.618 5.973 22.5 7.37 22.5 9v.066c0 .964 0 2.169-.606 3.381a1 1 0 1 1-1.788-.894c.38-.76.394-1.528.394-2.553 0-.87-.471-1.734-1.332-2.413-.86-.68-2.04-1.109-3.255-1.109h-.93a1 1 0 0 1-.867-.5A5.954 5.954 0 0 0 8.957 2Zm1.851 8.029a1 1 0 0 1 1.385 0l4.083 3.918a1 1 0 1 1-1.384 1.443l-2.392-2.294v9.685a1 1 0 1 1-2 0v-9.685L8.11 15.39a1 1 0 1 1-1.385-1.443l4.083-3.918Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
